<!--
 * @Descripttion:
 * @version:
 * @Author: dengyao
 * @Date: 2023-06-24 13:51:27
 * @LastEditors: hongye
 * @LastEditTime: 2026-03-05 17:01:58
-->
<template>
  <Select
    v-model:value="state.value"
    show-search
    :placeholder="$lang('请输入站点名称/编号查询')"
    style="width: 100%"
    :filter-option="false"
    :not-found-content="state.fetching ? undefined : null"
    :options="state.data"
    :disabled="props.disabled"
    @search="fetchUser"
    @change="changeCode"
    allowClear
  >
    <template v-if="state.fetching" #notFoundContent>
      <spin size="small" />
    </template>
  </Select>
</template>
<script lang="ts" setup>
  import { reactive, toRef, watch } from 'vue'
  import { Select, Spin } from 'ant-design-vue'
  import { debounce } from 'lodash-es'
  import { siteService } from '@/service/api'
  interface Props {
    searchParam: any
    item: any
    value?: any
    disabled?: boolean
  }
  const props = defineProps<Props>()
  const emit = defineEmits(['update:value'])

  const state = reactive({
    data: [],
    value: '',
    fetching: false
  })

  const fetchUser = debounce((value) => {
    state.data = []
    state.fetching = true
    siteService.dimStation({ param: value }).then((res) => {
      state.fetching = false
      if (res.code === 1) {
        state.data = res.data.map((_: any) => {
          return {
            label: `${_.value} | ${_.key}`,
            value: _.key
          }
        })
      }
    })
  }, 300)

  const changeCode = (value: any) => {
    emit('update:value', value)
    props.searchParam[props.item.prop] = value
  }
  watch(
    () => props.searchParam[props.item.prop],
    (val) => {
      state.value = val
      if (props.item.selectDic) {
        state.data = props.item.selectDic
      }
    },
    {
      immediate: true,
      deep: true
    }
  )

  watch(toRef(state.value), () => {
    state.data = []
  })
  defineExpose({
    state
  })
</script>
